import { render, staticRenderFns } from "./DashboardClassificator.vue?vue&type=template&id=83507638&scoped=true"
import script from "./DashboardClassificator.vue?vue&type=script&lang=js"
export * from "./DashboardClassificator.vue?vue&type=script&lang=js"
import style0 from "./DashboardClassificator.vue?vue&type=style&index=0&id=83507638&prod&lang=scss&scoped=true"
import style1 from "./DashboardClassificator.vue?vue&type=style&index=1&id=83507638&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83507638",
  null
  
)

export default component.exports